module.exports = __webpack_public_path__ + "static/media/gras-logo.defd4155.svg";